import { useEffect, useState } from "react";
import Map from "./Map";
import LeftSide from "./LeftSide";
import RightSide from "./RightSide";
import AboutViewerModal from "./modal/AboutViewerModal";
import PlateauModal from "./modal/PlateauModal";
import LoginPromptModal from "./modal/LoginPromptModal";
import BuyRegistryModal from "./modal/BuyRegistryModal";

const Body = () => {
  // Aboutダイアログ
  const [showAboutViewerModal, setShowAboutViewerModal] = useState(false);
  // Aboutダイアログで開く章の指定（指定なしは全章を閉じたまま開く）
  const [aboutSectionRequest, setAboutSectionRequest] = useState(null);
  // プラトーダイアログ
  const [showPlateauModal, setShowPlateauModal] = useState(false);
  // ログインプロンプトダイアログ
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [showLoginButtonInPrompt, setShowLoginButtonInPrompt] = useState(false);
  // 謄本購入ダイアログ
  const [showBuyRegistryModal, setShowBuyRegistryModal] = useState(false);

  useEffect(() => {
    // Aboutダイアログ表示用イベントリスナー
    const handleShowAboutViewerModal = (event) => {
      const section = event?.detail?.section ?? null;
      // 同じ章を続けて指定されても開く処理が再実行されるよう seq を持たせる
      setAboutSectionRequest(section ? { section, seq: Date.now() } : null);
      setShowAboutViewerModal(true);
    };
    window.addEventListener("showAboutViewerModal", handleShowAboutViewerModal);

    // プラトーダイアログ表示用イベントリスナー
    const handleShowPlateauModal = () => {
      setShowPlateauModal(true);
    };
    window.addEventListener("showPlateauModal", handleShowPlateauModal);

    // ログインプロンプトダイアログ表示用イベントリスナー
    const handleShowLoginPrompt = (event) => {
      setShowLoginButtonInPrompt(event.detail.showButton);
      setShowLoginPrompt(true);
    };
    window.addEventListener("showLoginPrompt", handleShowLoginPrompt);

    // 謄本購入ダイアログ表示用イベントリスナー
    const handleShowBuyRegistryModal = (event) => {
      if (event?.detail?.isCloseModal) {
        setShowBuyRegistryModal(false);
      } else {
        setShowBuyRegistryModal(true);
      }
    };
    window.addEventListener("showBuyRegistryModal", handleShowBuyRegistryModal);

    return () => {
      window.removeEventListener(
        "showAboutViewerModal",
        handleShowAboutViewerModal
      );
      window.removeEventListener("showPlateauModal", handleShowPlateauModal);
      window.removeEventListener("showLoginPrompt", handleShowLoginPrompt);
      window.removeEventListener(
        "showBuyRegistryModal",
        handleShowBuyRegistryModal
      );
    };
  }, []);

  const handleLoginClick = () => {
    setShowLoginPrompt(false);
    // ログインダイアログ表示イベントを発行
    window.dispatchEvent(new CustomEvent("showAuthenticator"));
  };

  return (
    <div id="bodyArea">
      <Map />
      <LeftSide />
      <RightSide />
      <AboutViewerModal
        show={showAboutViewerModal}
        handleClose={() => {
          setShowAboutViewerModal(false);
          setAboutSectionRequest(null);
        }}
        showPlateauModal={() => setShowPlateauModal(true)}
        sectionRequest={aboutSectionRequest}
      />
      <PlateauModal
        show={showPlateauModal}
        handleClose={() => setShowPlateauModal(false)}
      />
      <LoginPromptModal
        show={showLoginPrompt}
        handleClose={() => setShowLoginPrompt(false)}
        showLoginButton={showLoginButtonInPrompt}
        onLoginClick={handleLoginClick}
      />
      <BuyRegistryModal
        show={showBuyRegistryModal}
        handleClose={() => setShowBuyRegistryModal(false)}
      />
    </div>
  );
};

export default Body;